import React, { useCallback, useEffect, useRef, useState } from "react";
import { Video, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, API, formatApiError } from "@/lib/api";

export default function MenuVideoManager() {
  const [info, setInfo] = useState({ present: false, updated_at: "" });
  const [uploading, setUploading] = useState(false);
  const ref = useRef(null);

  const load = useCallback(async () => {
    try { const r = await api.get("/settings"); setInfo({ present: r.data.menu_video, updated_at: r.data.menu_video_updated_at }); } catch (e) { /* ignore */ }
  }, []);
  useEffect(() => { load(); }, [load]);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 30 * 1024 * 1024) return toast.error("Vídeo muito grande (máx. 30MB).");
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try { await api.post("/admin/menu-video", fd); await load(); toast.success("Vídeo do menu atualizado!"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setUploading(false); }
  };
  const remove = async () => {
    try { await api.delete("/admin/menu-video"); await load(); toast.success("Vídeo removido."); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const src = info.present ? `${API}/settings/menu-video?v=${encodeURIComponent(info.updated_at || "")}` : null;

  return (
    <div className="mb-8" data-testid="menu-video-manager">
      <div className="flex items-center gap-2">
        <Video className="h-5 w-5 text-[#1B7A45]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">Vídeo de fundo do menu</h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">Toca sem som, em loop, atrás da página de menu. MP4/WEBM/MOV · máx. 30MB (prefira clipes curtos, até ~10MB, para carregar rápido).</p>
      <div className="mt-3 max-w-md rounded-2xl border border-slate-200 bg-white p-3">
        <div className="flex h-36 items-center justify-center overflow-hidden rounded-xl bg-[#0b1610] text-slate-500">
          {src ? <video src={src} muted loop autoPlay playsInline className="h-full w-full object-cover" /> : <Video className="h-8 w-8" />}
        </div>
        <input ref={ref} type="file" accept="video/mp4,video/webm,video/quicktime" onChange={onFile} className="hidden" data-testid="menu-video-input" />
        <div className="mt-2 flex gap-2">
          <Button data-testid="menu-video-upload" onClick={() => ref.current?.click()} disabled={uploading} className="flex-1 rounded-xl bg-[#E8611A] text-white hover:bg-[#CF5212]"><Video className="mr-1.5 h-4 w-4" /> {uploading ? "Enviando..." : info.present ? "Trocar vídeo" : "Enviar vídeo"}</Button>
          {info.present && <Button data-testid="menu-video-remove" onClick={remove} variant="outline" className="rounded-xl border-red-200 bg-red-50 text-red-600"><Trash2 className="h-4 w-4" /></Button>}
        </div>
      </div>
    </div>
  );
}
